const DEBUG_LEVELS = Object.freeze({
  LOG: 'log',
  INFO: 'info',
  WARN: 'warn',
  ERROR: 'error',
});

Debug = {};
Debug.defaults = Object.freeze({
  enabled: false,
  forceEnabled: false,
  onScreen: false,
  forceOnScreen: false,
  maxHistory: 100,
  styles: {
    display: {
      position: 'fixed',
      'z-index': 99999,
      padding: '10px',
      'background-color': 'grey',
      bottom: '0px',
      left: '0%',
      width: '100%',
      height: '25%',
      opacity: 1,
      reducedSize: 50,
    },
    entry: {
      overflow: 'hidden scroll',
      'list-style-type': 'none',
      'user-select': 'text',
      color: 'black',
      'padding-inline-start': 0,
      margin: 0,
      width: '98%',
      height: '100%',
    },
    logs: {
      [DEBUG_LEVELS.LOG]: {
        'background-color': '#808080',
        color: '#ffffff',
        'font-size': '12px',
        padding: null,
        'font-family': 'monospace',
        displayStack: false,
      },
      [DEBUG_LEVELS.INFO]: {
        'background-color': '#808080',
        color: '#ffffff',
        'font-size': '12px',
        padding: null,
        'font-family': 'monospace',
        displayStack: false,
      },
      [DEBUG_LEVELS.WARN]: {
        'background-color': '#ff9500ff',
        color: '#000000ff',
        'font-size': '13px',
        padding: '1px',
        'font-family': 'monospace',
        displayStack: false,
      },
      [DEBUG_LEVELS.ERROR]: {
        'background-color': '#FF0000',
        color: '#FFFFFF',
        'font-size': '14px',
        padding: '1px',
        'font-family': 'monospace',
        displayStack: true,
      },
    },
  },
});

Debug.takenOver = false;
Debug.initialised = false;
Debug.initData = {};
Debug.history = [];
Debug.logCount = 0;
Debug.displayDiv = null;
Debug.entryList = null;

Debug.initialise = function (initData) {
  if (!Debug.initialised) {
    Debug.initData = $.extend(true, {}, Debug.defaults, initData);
    Debug.initialised = true;
    if (Debug.initData.onScreen === true || Debug.initData.forceOnScreen) {
      Debug.createOnScreen();
    }
  }
};

Debug.applyStyleTo = function (div, styleInfo) {
  let keys = Object.keys(styleInfo);
  for (let i = 0; i < keys.length; i++) {
    if (typeof div.style[keys[i]] !== 'undefined') {
      div.style[keys[i]] = styleInfo[keys[i]];
    }
  }
};

Debug.createOnScreen = function () {
  const gameContainer = document.getElementsByClassName('canvasContainer')[0];
  if (gameContainer) {
    const styleData = Debug.initData.styles.display;
    const { width, height, reducedSize } = styleData;

    const container = gameContainer || document.body;
    Debug.displayDiv = document.createElement('div');
    Debug.applyStyleTo(Debug.displayDiv, Debug.initData.styles.display);
    container.appendChild(Debug.displayDiv);

    // listen for double click events to minimise
    Debug.touchStartDetected = 0;
    Debug.displayDiv.addEventListener('dblclick', () => {
      Debug.resizeDisplay(width, height, reducedSize);
    });
    Debug.displayDiv.addEventListener('touchstart', () => {
      if (!Debug.touchStartDetected) {
        Debug.touchStartDetected = Date.now();
      } else {
        if (Date.now() - Debug.touchStartDetected < 1000) {
          Debug.resizeDisplay(width, height, reducedSize);
          Debug.touchStartDetected = 0;
        } else {
          Debug.touchStartDetected = Date.now();
        }
      }
    });

    Debug.entryList = document.createElement('ul');
    Debug.applyStyleTo(Debug.entryList, Debug.initData.styles.entry);
    Debug.displayDiv.appendChild(Debug.entryList);

    for (let i = 0; i < Debug.history.length; i++) {
      Debug.logToDisplay(Debug.history[i]);
    }
  }
};

// use this function to always output to the console
Debug.log = function () {
  const args = Array.prototype.splice.call(arguments, 0);
  const log = Debug.createLog(args, DEBUG_LEVELS.LOG, null);
  Debug.storeLog(log);
  Debug.logToDisplay(log);

  if (Debug.takenOver === true) {
    Debug.origLog.apply(this, args);
  } else {
    console.log.apply(this, args);
  }
};

Debug.info = function () {
  const args = Array.prototype.splice.call(arguments, 0);
  const log = Debug.createLog(args, DEBUG_LEVELS.INFO, null);
  Debug.storeLog(log);
  Debug.logToDisplay(log);

  if (Debug.takenOver === true) {
    Debug.origInfo.apply(this, args);
  } else {
    console.info.apply(this, args);
  }
};

Debug.warn = function () {
  const args = Array.prototype.splice.call(arguments, 0);
  const log = Debug.createLog(args, DEBUG_LEVELS.WARN, null);
  Debug.storeLog(log);
  Debug.logToDisplay(log);

  if (Debug.takenOver === true) {
    Debug.origWarn.apply(this, args);
  } else {
    console.warn.apply(this, args);
  }
};

Debug.takeOver = function () {
  Debug.origLog = console.log;
  Debug.origInfo = console.info;
  Debug.origWarn = console.warn;
  Debug.origError = console.error;

  console.log = function () {
    // do we still want to add to the history and on screen display? even if disabled?
    // i think we should
    const args = Array.prototype.splice.call(arguments, 0);
    const log = Debug.createLog(args, DEBUG_LEVELS.LOG, null);
    Debug.storeLog(log);
    Debug.logToDisplay(log);

    if (!Debug.initialised || Debug.isEnabled() || Debug.initData.forceEnabled) {
      if (Debug.initialised) {
        args[0] = log.prefix + ' ' + args[0];
      }
      Debug.origLog.apply(this, args);
    }
  };

  console.info = function () {
    const args = Array.prototype.splice.call(arguments, 0);
    const log = Debug.createLog(args, DEBUG_LEVELS.INFO, null);
    Debug.storeLog(log);
    Debug.logToDisplay(log);

    let force = false;
    if (args[0] instanceof PIXI.Container) {
      force = true;
    }

    if (force || !Debug.initialised || Debug.isEnabled() || Debug.initData.forceEnabled) {
      if (Debug.initialised) {
        if (args[0] instanceof PIXI.Container) {
          // dbl clicked pixi component in the dev tools
          args.unshift(log.prefix + ' Pixi Component');
        } else {
          args[0] = log.prefix + ' ' + args[0];
        }
      }
      Debug.origInfo.apply(this, args);
    }
  };

  console.warn = function () {
    const args = Array.prototype.splice.call(arguments, 0);
    const log = Debug.createLog(args, DEBUG_LEVELS.WARN, null);
    Debug.storeLog(log);
    Debug.logToDisplay(log);

    if (!Debug.initialised || Debug.isEnabled() || Debug.initData.forceEnabled) {
      if (Debug.initialised) {
        args[0] = log.prefix + ' ' + args[0];
      }
      Debug.origWarn.apply(this, args);
    }
  };

  console.error = function () {
    const args = Array.prototype.splice.call(arguments, 0);
    const log = Debug.createLog(args, DEBUG_LEVELS.ERROR, null);
    Debug.storeLog(log);
    Debug.logToDisplay(log);

    if (Debug.initialised) {
      args[0] = log.prefix + ' ' + args[0];
    }
    Debug.origError.apply(this, args);
  };

  Debug.takenOver = true;
};

Debug.createLog = function (args, level, stackTrace) {
  let output = '';
  for (let i = 0; i < args.length; i++) {
    let msg = args[i];
    if (msg instanceof PIXI.Container) {
      msg = 'Pixi component dbl clicked in dev tools';
    } else {
      if (Object.prototype.toString.call(args[i]) === '[object Object]') {
        msg = JSON.stringify(args[i]);
      }
    }

    output += msg + ' ';
  }

  const time = Debug.getTime();
  const log = {
    prefix: `<${gameData.gameNameShort} v${gameData.version} ${Debug.logCount} - ${time}>`,
    message: output,
    level: level,
    stackTrace: stackTrace,
  };

  Debug.logCount++;

  return log;
};

Debug.getTime = function () {
  const date = new Date();
  const hours = date.getHours();
  const mins = date.getMinutes();
  const secs = date.getSeconds();
  const ms = date.getMilliseconds();
  let msText = ms;
  if (ms < 10) {
    msText = '00' + ms;
  } else if (ms < 100) {
    msText = '0' + ms;
  }
  const time = `${hours < 10 ? '0' + hours : hours}:${mins < 10 ? '0' + mins : mins}:${
    secs < 10 ? '0' + secs : secs
  }.${msText}`;

  return time;
};

Debug.force = function () {
  console.log.apply(console, arguments);
};

Debug.disable = function () {
  Debug.initData.enabled = false;
  if (Debug.displayDiv) {
    const gameContainer = document.getElementsByClassName('canvasContainer')[0];
    gameContainer.removeChild(Debug.displayDiv);
  }
};

Debug.enable = function () {
  if (Debug.initialised === true) {
    if (!Debug.initData.enabled) {
      Debug.initData.enabled = true;
      if (Debug.initData.onScreen === true || Debug.initData.forceOnScreen) {
        if (!Debug.displayDiv) {
          Debug.createOnScreen();
        } else {
          const gameContainer = document.getElementsByClassName('canvasContainer')[0];
          gameContainer.appendChild(Debug.displayDiv);
        }
      }
    }
  }
};

Debug.isEnabled = function () {
  return Debug.initData.enabled;
};

Debug.enabledViaURLParam = function () {
  let enable = false;
  if (window._POST_PARAMS_) {
    enable = window._POST_PARAMS_._debugOutput === 'on';
  } else {
    let urlParams = {};
    const getParameterByName = function (url) {
      let match;
      const pl = /\+/g, // Regex for replacing addition symbol with a space
        search = /([^&=]+)=?([^&]*)/g,
        decode = function (s) {
          return decodeURIComponent(s.replace(pl, ' '));
        },
        query = url.substring(1);

      urlParams = {};
      while ((match = search.exec(query))) urlParams[decode(match[1])] = decode(match[2]);
    };

    let url = window.location.href;
    url = url.substring(url.indexOf('?'), url.length);
    getParameterByName(url);
    enable = urlParams._debugOutput === 'on';
  }
  return enable;
};

Debug.onScreenViaURLParam = function () {
  let onScreen = false;
  if (window._POST_PARAMS_) {
    onScreen = window._POST_PARAMS_._debugOutputToScreen === 'on';
  } else {
    let urlParams = {};
    const getParameterByName = function (url) {
      let match;
      const pl = /\+/g, // Regex for replacing addition symbol with a space
        search = /([^&=]+)=?([^&]*)/g,
        decode = function (s) {
          return decodeURIComponent(s.replace(pl, ' '));
        },
        query = url.substring(1);

      urlParams = {};
      while ((match = search.exec(query))) urlParams[decode(match[1])] = decode(match[2]);
    };

    let url = window.location.href;
    url = url.substring(url.indexOf('?'), url.length);
    getParameterByName(url);
    onScreen = urlParams._debugOutputToScreen === 'on';
  }
  return onScreen;
};

Debug.storeLog = function (log) {
  Debug.history.push(log);

  if (Debug.history.length > Debug.initData.maxHistory) {
    Debug.history.shift();
    if (Debug.displayDiv !== null && Debug.entryList !== null) {
      Debug.entryList.removeChild(Debug.entryList.firstChild);
    }
  }
};

Debug.logToDisplay = function (log) {
  if (Debug.displayDiv !== null && Debug.entryList !== null) {
    const style = Debug.initData.styles.logs[log.level];
    const listElement = document.createElement('li');

    Debug.applyStyleTo(listElement, style);
    listElement.innerText = `${log.prefix} ${log.message}`;

    if (style.displayStack) {
      listElement.innerText += ` :: ${!log.stackTrace ? Error().stack : log.stackTrace}`;
    }

    Debug.entryList.appendChild(listElement);
    Debug.entryList.scrollTop = Debug.entryList.scrollHeight - Debug.entryList.clientHeight;
  }
};

Debug.resizeDisplay = function (width, height, reducedSize) {
  if (Debug.displayDiv.style.width === width && Debug.displayDiv.style.height === height) {
    Debug.displayDiv.style.width = `${reducedSize}px`;
    Debug.displayDiv.style.height = `${reducedSize}px`;
  } else {
    Debug.displayDiv.style.width = width;
    Debug.displayDiv.style.height = height;
  }
};

// take over regardless - any console message will be stored in the history and be
// added after creation if required
Debug.takeOver();

resourceManager.createConfigurationOverride = resourceManager.createConfiguration;
resourceManager.createConfiguration = function (filename, configurationData) {
  const config = JSON.parse(configurationData);
  let debugCfg = $.extend(true, {}, config.debug);
  debugCfg.enabled = Debug.enabledViaURLParam();
  debugCfg.onScreen = Debug.onScreenViaURLParam();
  Debug.initialise(debugCfg);

  resourceManager.createConfigurationOverride(filename, configurationData);
};
